import L from "leaflet";
import { useMemo, useState } from "react";
import { Marker, Tooltip, useMap, useMapEvents } from "react-leaflet";

export const STAFF_GROUPS = {
  policia: { label: "Policía Local", svg: `<path d="M12 1.5 L21 5 V11.5 C21 17 17 21 12 22.5 C7 21 3 17 3 11.5 V5 Z" fill="#1d4ed8" stroke="#fff" stroke-width="1.5"/><path d="M12 6.5 L13.6 10 L17.3 10.3 L14.5 12.7 L15.4 16.4 L12 14.4 L8.6 16.4 L9.5 12.7 L6.7 10.3 L10.4 10 Z" fill="#fde047"/>` },
  pc: { label: "Protección Civil", svg: `<circle cx="12" cy="12" r="11" fill="#f97316" stroke="#fff" stroke-width="1.5"/><path d="M12 5 L19 18 H5 Z" fill="#1e3a8a"/>` },
  voluntarios: { label: "Voluntarios / auxiliares", svg: `<circle cx="12" cy="12" r="11" fill="#16a34a" stroke="#fff" stroke-width="1.5"/><circle cx="12" cy="8" r="3" fill="#fff"/><path d="M6 19 C6 14.5 8.5 12.5 12 12.5 C15.5 12.5 18 14.5 18 19 Z" fill="#fff"/>` },
};

export const staffSvg = (g, size = 18) => `<svg width="${size}" height="${size}" viewBox="0 0 24 24">${STAFF_GROUPS[g].svg}</svg>`;

export const StaffMini = ({ group, size = 14 }) => (
  <span className="inline-flex shrink-0" dangerouslySetInnerHTML={{ __html: staffSvg(group, size) }} />
);

// Icono de cada tipo de unidad en su puesto: coche y moto de policía, silueta de agente (a pie y, en dorado, mando),
// «AUX» para auxiliares, «P.C.» para Protección Civil y chaleco reflectante amarillo para organización y colaboradores
const UNIT_SVG = {
  patrullas_coche: `<rect x="1" y="9" width="22" height="8" rx="2.5" fill="#1d4ed8"/><path d="M5 9 L8 4.5 H16 L19 9 Z" fill="#1d4ed8"/><path d="M8.6 8.6 L9.9 5.6 H14.1 L15.4 8.6 Z" fill="#bfdbfe"/><rect x="1" y="12" width="22" height="1.6" fill="#fff"/><rect x="10" y="2.4" width="4" height="2" rx=".6" fill="#ef4444"/><circle cx="6.5" cy="17.5" r="2.4" fill="#0f172a" stroke="#fff" stroke-width="1"/><circle cx="17.5" cy="17.5" r="2.4" fill="#0f172a" stroke="#fff" stroke-width="1"/>`,
  patrullas_moto: `<circle cx="5.5" cy="16.5" r="3.6" fill="none" stroke="#0f172a" stroke-width="2"/><circle cx="18.5" cy="16.5" r="3.6" fill="none" stroke="#0f172a" stroke-width="2"/><path d="M5.5 16.5 L10 11 H15 L18.5 16.5" stroke="#1d4ed8" stroke-width="2.4" fill="none" stroke-linejoin="round"/><path d="M9 11 L11.5 8 H15.5 L16.8 11 Z" fill="#1d4ed8"/><rect x="15.5" y="5.6" width="3" height="1.7" rx=".5" fill="#ef4444"/><circle cx="12.6" cy="5.8" r="2" fill="#1d4ed8"/>`,
  policia_pie: `<circle cx="12" cy="7.2" r="3.4" fill="#1d4ed8"/><path d="M7.8 4.8 H16.2 L15 2.6 H9 Z" fill="#0f172a"/><path d="M5 22 C5 15.5 8 12.5 12 12.5 C16 12.5 19 15.5 19 22 Z" fill="#1d4ed8"/><path d="M12 13.2 L13.1 16 L12 17.2 L10.9 16 Z" fill="#fde047"/>`,
  mandos: `<circle cx="12" cy="7.2" r="3.4" fill="#1e3a8a"/><path d="M7.8 4.8 H16.2 L15 2.6 H9 Z" fill="#b45309"/><path d="M5 22 C5 15.5 8 12.5 12 12.5 C16 12.5 19 15.5 19 22 Z" fill="#1e3a8a"/><path d="M6.5 15.5 H9.5 M14.5 15.5 H17.5" stroke="#f59e0b" stroke-width="1.8"/><path d="M12 16 L13 18.2 L15.3 18.4 L13.5 19.9 L14.1 22 L12 20.8 L9.9 22 L10.5 19.9 L8.7 18.4 L11 18.2 Z" fill="#f59e0b"/>`,
  organizadores: `<path d="M8 2 L12 5 L16 2 L20 5 L19 22 H5 L4 5 Z" fill="#facc15" stroke="#a16207" stroke-width="1"/><path d="M12 5 V22" stroke="#a16207" stroke-width="1"/><rect x="4.7" y="12.5" width="14.6" height="2.2" fill="#e5e7eb" stroke="#9ca3af" stroke-width=".4"/><rect x="4.9" y="17" width="14.2" height="2.2" fill="#e5e7eb" stroke="#9ca3af" stroke-width=".4"/>`,
};
const UNIT_TEXT = { auxiliares: { txt: "AUX", bg: "#16a34a", fg: "#fff" }, proteccion_civil: { txt: "P.C.", bg: "#f97316", fg: "#1e3a8a" } };
const CON_DATOS = ["patrullas_coche", "patrullas_moto", "policia_pie", "mandos"];  // llevan al lado la nota y los TIP
const ORDEN = ["mandos", "patrullas_coche", "patrullas_moto", "policia_pie", "auxiliares", "proteccion_civil", "organizadores"];
const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const unitIconHtml = (t, size = 20) => (UNIT_SVG[t]
  ? `<svg width="${size}" height="${size}" viewBox="0 0 24 24">${UNIT_SVG[t]}</svg>`
  : UNIT_TEXT[t] ? `<span style="display:inline-block;background:${UNIT_TEXT[t].bg};color:${UNIT_TEXT[t].fg};border-radius:4px;padding:0 3px;font:800 9px/${size - 4}px sans-serif;letter-spacing:.02em">${UNIT_TEXT[t].txt}</span>` : "");

// agrupa las unidades del puesto por tipo y nota (una patrulla «Lima 6» con sus TIP, tres agentes «Turno mañana»…)
const bloques = (items) => {
  const out = [];
  items.forEach((it) => {
    const k = CON_DATOS.includes(it.t) ? `${it.t}|${it.nota}` : it.t;
    let b = out.find((x) => x.k === k);
    if (!b) { b = { k, t: it.t, nota: it.nota, tips: [], n: 0 }; out.push(b); }
    b.n += 1;
    if (it.tip) b.tips.push(it.tip.replace(/\s*\/\s*/g, " / "));
  });
  return out.sort((a, b) => ORDEN.indexOf(a.t) - ORDEN.indexOf(b.t));
};

const staffHtml = (p, sel) => {
  const items = p.items || [];
  if (!items.length) {  // planes antiguos sin el detalle de cada unidad: como antes, un escudo por colectivo
    const chips = Object.keys(STAFF_GROUPS).filter((g) => p.groups[g]).map((g) =>
      `<span style="display:inline-flex;align-items:center;gap:2px;background:#0f172aee;border:1px solid #ffffff55;border-radius:10px;padding:1px 5px 1px 2px;color:#fff;font:700 10px/16px sans-serif">${staffSvg(g, 16)}${p.groups[g]}</span>`).join("");
    return `<div style="display:flex;gap:2px;white-space:nowrap;filter:drop-shadow(0 1px 2px #000);${sel ? "outline:2px solid #38bdf8;outline-offset:2px;border-radius:12px;" : ""}">${chips}</div>`;
  }
  const html = bloques(items).map((b) => {
    const datos = CON_DATOS.includes(b.t) && (b.nota || b.tips.length)
      ? `<span style="display:flex;flex-direction:column;line-height:1.15">${b.nota ? `<b style="font:700 10px sans-serif;color:#0f172a">${esc(b.nota)}</b>` : ""}${b.tips.length ? `<span style="font:600 9px ui-monospace,monospace;color:#334155">TIP ${esc(b.tips.join(" · "))}</span>` : ""}</span>`
      : "";
    const n = !CON_DATOS.includes(b.t) || !b.tips.length ? (b.n > 1 ? `<b style="font:700 10px sans-serif;color:#0f172a">×${b.n}</b>` : "") : "";
    return `<span style="display:inline-flex;align-items:center;gap:3px;background:#ffffffee;border:1px solid #94a3b8;border-radius:8px;padding:1px 5px 1px 2px">${unitIconHtml(b.t)}${datos}${n}</span>`;
  }).join("");
  return `<div style="display:flex;flex-wrap:wrap;gap:2px;width:max-content;max-width:240px;filter:drop-shadow(0 1px 2px #0008);${sel ? "outline:2px solid #38bdf8;outline-offset:2px;border-radius:10px;" : ""}">${html}</div>`;
};

// tamaño real de la etiqueta en pantalla (se mide una vez por contenido)
const TAM = new Map();
const medir = (html) => {
  if (!TAM.has(html)) {
    const d = document.createElement("div");
    d.style.cssText = "position:absolute;visibility:hidden;left:-9999px;top:0";
    d.innerHTML = html;
    document.body.appendChild(d);
    TAM.set(html, [d.firstChild?.offsetWidth || 60, d.firstChild?.offsetHeight || 20]);
    d.remove();
  }
  return TAM.get(html);
};

// Etiquetas que no tapan: cada una prueba seis sitios alrededor de su puesto (arriba o abajo a la derecha, a la izquierda,
// encima o debajo) y se queda con el que no pisa señales, cortes, números de puesto ni otras etiquetas. Se recalcula al hacer zoom.
const sitios = (w, h) => [[10, -h + 4], [10, 6], [-10 - w, -h + 4], [-10 - w, 6], [-w / 2, -h - 16], [-w / 2, 16]];
const colocar = (map, zoom, pts, htmls, obstaculos) => {
  const P = (ll) => map.project(ll, zoom);
  const obs = obstaculos.map(P);
  const hechas = [];
  return pts.map((p, i) => {
    const [w, h] = medir(htmls[i]);
    const c = P(p.loc);
    let mejor = null;
    sitios(w, h).forEach(([dx, dy], k) => {
      const r = { x: c.x + dx, y: c.y + dy, w, h };
      let s = k * 0.1;  // a igualdad, el sitio de siempre (arriba a la derecha)
      obs.forEach((o) => {
        if (Math.abs(o.x - c.x) + Math.abs(o.y - c.y) < 4) return;  // el propio puesto
        if (o.x > r.x - 15 && o.x < r.x + w + 15 && o.y > r.y - 15 && o.y < r.y + h + 15) s += 10;
      });
      hechas.forEach((q) => { if (r.x < q.x + q.w + 2 && q.x < r.x + w + 2 && r.y < q.y + q.h + 2 && q.y < r.y + h + 2) s += 8; });
      if (!mejor || s < mejor.s) mejor = { ...r, dx, dy, s };
    });
    hechas.push(mejor);
    return [-mejor.dx, -mejor.dy];
  });
};

export const StaffMarkers = ({ points = [], minZoom = 15, onSelect, selectedKey, onMove, obstacles = [] }) => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  useMapEvents({ zoomend: () => setZoom(map.getZoom()) });
  return zoom < minZoom && !selectedKey ? null : <StaffList points={points} onSelect={onSelect} selectedKey={selectedKey} onMove={onMove} map={map} zoom={zoom} obstacles={obstacles} />;
};

const StaffList = ({ points, onSelect, selectedKey, onMove, map, zoom, obstacles }) => {
  const htmls = points.map((p) => staffHtml(p, p.key === selectedKey));
  const anclas = useMemo(() => colocar(map, zoom, points, htmls, obstacles), [map, zoom, points, htmls.join("|"), obstacles]); // eslint-disable-line react-hooks/exhaustive-deps
  return points.map((p, i) => (
  <Marker key={`staff-${p.key || i}-${p.loc[0]}-${p.loc[1]}`} position={p.loc} icon={L.divIcon({ className: "", html: htmls[i], iconSize: [40, 18], iconAnchor: anclas[i] })} interactive={!!p.tasks?.length}
    draggable={!!onMove && p.key === selectedKey} zIndexOffset={p.key === selectedKey ? 900 : 0}
    eventHandlers={{
      click: (e) => { e.originalEvent && L.DomEvent.stopPropagation(e); onSelect && onSelect(p.key); },
      dragend: (e) => { const ll = e.target.getLatLng(); onMove(p.key, [+ll.lat.toFixed(6), +ll.lng.toFixed(6)]); },
    }}>
    {p.tasks?.length > 0 && (
      <Tooltip direction="top" offset={[30, -24]}>
        <div className="text-xs max-w-[260px] whitespace-normal">
          {Object.keys(STAFF_GROUPS).filter((g) => p.groups[g]).map((g) => <div key={g}><b>{STAFF_GROUPS[g].label}:</b> {p.groups[g]} · {(p.units?.[g] || []).map((k) => (p.items || []).find((it) => it.uid === k)?.n || k).join(", ")}</div>)}
          <div className="text-slate-500 mt-1">{p.tasks.map((t, j) => <div key={j}>· {t}</div>)}</div>
        </div>
      </Tooltip>
    )}
  </Marker>
  ));
};

// leyenda: un icono por tipo de unidad
export const UNIT_LEGEND = [["patrullas_coche", "Patrulla en vehículo"], ["patrullas_moto", "Patrulla en moto"], ["policia_pie", "Agente a pie"],
  ["mandos", "Mando"], ["auxiliares", "Auxiliar"], ["proteccion_civil", "Protección Civil"], ["organizadores", "Organización / colaborador"]];
export const UnitMini = ({ type, size = 14 }) => <span className="inline-flex shrink-0 items-center" dangerouslySetInnerHTML={{ __html: unitIconHtml(type, size) }} />;
